var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-show=\"vm.panels.categoryPanel\" flex=\"20\" layout-padding=\"layout-padding\" class=\"detailRightPanel\"><md-content layout-padding=\"layout-padding\" style=\"background: transparent\"><div layout=\"row\" layout-align=\"end start\"><md-button ng-click=\"vm.closePanels('categoryPanel')\">Close</md-button></div><div layout=\"row\"><div layout=\"column\"><h3>Add Category</h3><lookups tm-data-source=\"IngredientCategories\" limit-to-list=\"limit-to-list\" doc-list=\"vm.docSvc.doc.categories\" list=\"root\" doc-service-add-method=\"tmIngredientDocSvc.addCategory\"><div style=\"border: solid black 1px; background-color: white\" class=\"itemCard\"><a href=\"\" ng-click=\"dCtrl.addItem(item)\"> <span class=\"glyphicon glyphicon-circle-arrow-left\"> </span></a><span>&nbsp; {{item}}</span></div></lookups></div></div></md-content></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/production/ingredients/tabs/panel-categories.jade
// module id = 210
// module chunks = 0